import React, { useCallback } from 'react';
import { Grid, Layout } from 'antd';
import classnames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import App from 'routes/index';
import { AccountStatusContent, AccountStatusProvider } from '@src/packages/accountStatus';
import SecondaryPanel, {
  SecondaryPanelProvider,
} from '@src/components/SecondaryPanel/SecondaryPanel';

import Sidebar from '../Sidebar/index';
import Topbar from '../Topbar/index';
import { shouldShowMobileTopbar } from './shouldShowMobileTopbar';
import { toggleCollapsedSideNav } from 'appRedux/actions/Setting';
import { TAB_SIZE } from '../../constants/ThemeSetting';
import styles from './styles.module.less';

const { useBreakpoint } = Grid;

const MainApp = () => {
  const screens = useBreakpoint();
  const showTopbar = shouldShowMobileTopbar(screens);
  const dispatch = useDispatch();
  const { navCollapsed, width } = useSelector(({ common }) => common);
  const isMobileNavOpen = width < TAB_SIZE && navCollapsed;
  const closeMobileNav = useCallback(event => {
    if (!isMobileNavOpen) return;

    if (event.target.closest?.('[data-mobile-nav-toggle]')) return;

    event.preventDefault();
    event.stopPropagation();
    dispatch(toggleCollapsedSideNav(false));
  }, [dispatch, isMobileNavOpen]);

  return (
    <AccountStatusProvider>
      <SecondaryPanelProvider>
        <Layout className="gx-app-layout">
          <Sidebar />
          <Layout
            className={classnames(styles.mainContent, isMobileNavOpen && styles.mobileNavOpen)}
            onClickCapture={closeMobileNav}
          >
            {showTopbar ? <Topbar /> : null}
            <AccountStatusContent>
              <App />
            </AccountStatusContent>
            <SecondaryPanel />
          </Layout>
        </Layout>
      </SecondaryPanelProvider>
    </AccountStatusProvider>
  );
};
export default React.memo(MainApp);
